import type { FC, ReactNode, HTMLAttributes } from 'react'

import { cn } from '@/utils'

interface GroupTimingsRowProps extends HTMLAttributes<HTMLDivElement> {
  Duration: ReactNode
  Range: ReactNode
}

export const GroupTimingsRow: FC<GroupTimingsRowProps> = ({
  Duration,
  Range,
  className,
  ...divProps
}) => {
  return (
    <div
      className={cn('w-full', className)}
      {...divProps}
    >
      <div className="flex items-baseline gap-3 px-5">
        {Duration}
        {Range}
      </div>
    </div>
  )
}
